import type { UserRole } from '@nzassa/shared';

const ROLE_REDIRECT: Partial<Record<UserRole, string>> = {
  SUPER_USER_ADMIN:    '/admin',
  ADMIN_ANSUT:         '/admin',
  TEAM_ANSUT:          '/admin',
  ADMIN_COLLEGE:       '/admin',
  EQUIPE_COLLEGE:      '/admin',
  FORMATEUR_PRINCIPAL: '/formateur',
  FORMATEUR_ASSISTANT: '/formateur',
  APPRENANT:           '/dashboard',
};

export function getDefaultRoute(role?: UserRole | null): string {
  if (!role) return '/dashboard';
  return ROLE_REDIRECT[role] ?? '/dashboard';
}
